import { openLoading, closeLoading } from "./swal";
export const TIMEOUT = parseInt('' + window.CLKEC_TIMEOUT) * 1000;
export const fetchError = function (error, arg1 = null, arg2 = null) {
    console.error('Error: ', error);
    closeLoading();
};
/**
 * Convierte un símbolo o identificador de moneda en su código ISO 4217 de 3 letras.
 *
 * @param {string} [value] - Símbolo o texto de moneda a normalizar.
 * @returns {string} Código ISO de 3 letras de la moneda (ej. 'USD', 'UYU').
 */
export function isoCurrency(value) {
    const rawCurrency = (value || (window.Clkec && window.Clkec.cart ? window.Clkec.cart.currency : '') || '').toString().trim();
    const normalized = rawCurrency.toUpperCase();
    if (normalized === 'US$' || normalized === 'U$S' || normalized === 'USD') {
        return 'USD';
    }
    if (normalized === '$' ||
        normalized === '$U' ||
        normalized === 'UY$' ||
        normalized === 'UYU' ||
        normalized === 'PESOS' ||
        normalized === '$UY') {
        return 'UYU';
    }
    if (normalized === 'ARS' || normalized === 'ARG$' || normalized === '$A') {
        return 'ARS';
    }
    if (normalized === 'BRL' || normalized === 'R$') {
        return 'BRL';
    }
    if (normalized === 'EUR' || normalized === '€') {
        return 'EUR';
    }
    if (rawCurrency.length === 3 && /^[A-Z]{3}$/i.test(rawCurrency)) {
        return rawCurrency.toUpperCase();
    }
    return 'UYU';
}
export function registerJsAddProductEvent(cart, btn, qtyValueSelector, attachedClass) {
    if (btn.classList.contains(attachedClass)) {
        return;
    }
    document.querySelectorAll(qtyValueSelector).forEach((el) => {
        if (!el.value) {
            el.value = '1';
        }
    });
    btn.addEventListener('click', function (event) {
        const target = event.currentTarget;
        const productRawData = target.closest('div').querySelector('input[name="raw-data"]');
        let product_content = productRawData.value;
        product_content = product_content.replace(/\r\n/g, '<br>');
        const productData = JSON.parse(product_content);
        if (productData['gifts']) {
            if (productData['gifts'].filter((val) => val['need_select']).length > 0) {
                window.location.href = '/product/' + productData['slug'];
                return;
            }
        }
        const qtyInput = document.querySelector(qtyValueSelector);
        let qty = (qtyInput === null || qtyInput === void 0 ? void 0 : qtyInput.value) || 1;
        try {
            if (!window.Clkec.cart.getCurrency() && productData.symbol) {
                window.Clkec.cart.setCurrency(productData.symbol);
            }
        }
        catch (e) { }
        cart.add_product({
            id: productData.id,
            code: productData.code,
            friendly_code: productData.friendly_code,
            brand: productData.brand,
            content: productData.content,
            name: productData.name,
            price: productData.price,
            image: productData.image,
            slug: productData.slug,
            symbol: productData.symbol,
            stock: 1,
        }, Number(qty));
        document.dispatchEvent(new CustomEvent('AddProductEvent', {
            'detail': {
                'event': event,
                'product': productData
            }
        }));
    });
    btn.classList.add(attachedClass);
}
export function registerJsAddProduct(cart) {
    const attachedClass = "js-add-event-attached";
    document.querySelectorAll(`.js-add-product:not(${attachedClass}`).forEach(function (addBtn) {
        registerJsAddProductEvent(cart, addBtn, '.js-qty-selector', attachedClass);
    });
}
export function registerJsFilters(cart) {
    document.querySelectorAll('.js-filterclick').forEach(function (opLink) {
        opLink.addEventListener('click', event => {
            const lnk = event.target;
            let value = lnk.dataset.value;
            let field = lnk.dataset.field;
            let selected = lnk.classList.contains('selected');
            let action = 'add';
            if (selected) {
                action = 'del';
            }
            queryListener(cart, field, value, action);
        });
    });
}
export function addParam(field, value, filters = null) {
    value = '' + value;
    if (filters == null) {
        filters = new URLSearchParams(location.search);
    }
    var values = filters.get(field);
    if (!values) {
        values = '';
    }
    values = values.toString();
    if (values) {
        values = values.split(',');
    }
    else {
        values = [];
    }
    if (values.indexOf(value) < 0) {
        values.push(value);
    }
    // Asegurándote de que `values` sea una cadena de texto
    values = values.toString();
    // Estableciendo el valor en el Map
    filters.set(field, values);
    // Convirtiendo el Map en un objeto correctamente
    window.filters = Object.fromEntries(filters.entries());
    // Retornando el Map
    return filters;
}
export function delParam(field, value) {
    value = '' + value;
    var filters = new URLSearchParams(location.search);
    if (filters.has(field)) {
        var values = filters.get(field);
        if (!values) {
            values = '';
        }
        values = values.toString();
        var arr_values = values.split(',');
        let i = arr_values.indexOf(value);
        if (i >= 0) {
            arr_values.splice(i, 1);
        }
        values = arr_values.toString();
        if (!values) {
            filters.delete(field);
        }
        else {
            filters.set(field, values);
        }
    }
    window.filters = Object.fromEntries(Array.from(filters.entries()));
    return filters;
}
const defaultOptions = { append: false };
export function render_items(cart, items, filters = new URLSearchParams(), options = defaultOptions) {
    if (!items) {
        return;
    }
    let page = filters.get('page');
    if (!page || page == '1') {
        if (!options.append) {
            document.getElementById('listing_products').innerHTML = '';
        }
    }
    let itemPTemplate = document.getElementById('product-item-template');
    if (!itemPTemplate) {
        console.log("Template 'product-item-template' does not exist");
        return;
    }
    let itemProductTemplate = itemPTemplate.innerHTML;
    let template = Handlebars.compile(itemProductTemplate);
    var items_content = '';
    items.forEach(function (el) {
        items_content += template(el);
    });
    if (items.length == 0 && page == '1') {
        document.getElementById('listing_products-no-products').classList.remove('d-none');
        var id_orden = document.querySelector('#id_orden');
        if (id_orden) {
            id_orden.classList.add('d-none');
        }
    }
    else {
        document.getElementById('listing_products-no-products').classList.add('d-none');
        var id_orden = document.querySelector('#id_orden');
        if (id_orden) {
            id_orden.classList.remove('d-none');
        }
    }
    document.getElementById('listing_products').insertAdjacentHTML('beforeend', items_content);
    registerJsAddProduct(cart);
    onFinishLoadProducts(cart);
}
export function render_sidebar(cart, items, filters) {
    let fltr = document.querySelector('#prefProduct .sidebar-filter-container');
    if (fltr) {
        fltr.innerHTML = render_sidebar_items(items);
    }
    registerJsFilters(cart);
}
export function render_actives(cart, items, filters) {
    let fltr = document.getElementById('activefilter');
    if (fltr) {
        fltr.innerHTML = render_actives_items(items);
    }
}
export function render_actives_items(items) {
    if (!items) {
        return;
    }
    window.actives = items;
    var filterActive_content = '';
    items.forEach(function (value) {
        var filterActiveTemplateEl = document.getElementById(`listings-active-template`);
        if (!filterActiveTemplateEl) {
            return;
        }
        var filterActiveTemplate = filterActiveTemplateEl.innerHTML;
        console.log('render_actives_items', value, filterActiveTemplate);
        let template = Handlebars.compile(filterActiveTemplate);
        filterActive_content += template(value);
    });
    return filterActive_content;
}
export function render_sidebar_items(items) {
    if (!items) {
        return;
    }
    //console.debug('render_sidebar_items', items)
    var filter_content = '';
    items.forEach(function (value) {
        //console.debug('render_sidebar_items', value)
        let tplId = `listings-filter-${value.type}-template`;
        var filterTemplate = document.getElementById(tplId);
        if (!filterTemplate) {
            return '';
        }
        let template = Handlebars.compile(filterTemplate.innerHTML);
        filter_content += template(value);
    });
    return filter_content;
}
export function render_orderby(cart, params) {
    let orderby = params.get('o');
    var orderByList = window.orders;
    if (!orderByList) {
        return;
    }
    document.querySelectorAll('.listings_orderby_container').forEach(orderby_container => {
        let container = orderby_container.querySelector('.control');
        container.innerHTML = '';
        let control = document.createElement('select');
        control.className = 'form-control form-control-sm px-3';
        control.innerHTML = '<option>...</option>';
        function orderByEvent(ev) {
            let top = ev.target;
            let index = top.options.selectedIndex - 1;
            let selection = '';
            if (index >= 0) {
                selection = orderByList[index][0];
            }
            params.set('o', selection);
            params.set('page', '1');
            query(cart, params, false, true);
        }
        orderByList.forEach(function (value) {
            let op = document.createElement('option');
            op.value = value[0];
            op.innerHTML = value[1];
            if (op.value == orderby) {
                op.selected = true;
            }
            control.appendChild(op);
        });
        control.addEventListener('change', orderByEvent);
        container.appendChild(control);
    });
}
function registerPaginationObserver(cart, el, page, params) {
    var plobserver = new IntersectionObserver(changes => {
        if (!cantLoadMore) {
            justQuery = page;
            gparams = params;
            return;
        }
        for (const change of changes) {
            if (change.isIntersecting) {
                params.set('page', page.toString());
                query(cart, params, false, true, { append: true });
            }
        }
    }, { rootMargin: "300px" });
    plobserver.observe(el);
}
function LoadMoreButton(cart, params, page, current_page) {
    if (page == current_page + 1) {
        let li = document.createElement('li');
        let a = document.createElement('a');
        a.innerText = 'Mostrar mas';
        li.classList.add('page-item');
        if (current_page == page) {
            li.classList.add('active');
        }
        a.className = 'btn btn-secondary pointer';
        a.addEventListener('click', function () {
            document.getElementById('listing_products').innerHTML = '';
            params.set('page', page.toString());
            query(cart, params, false, false);
        }, { once: true });
        registerPaginationObserver(cart, li, page, params);
        li.appendChild(a);
        return li;
    }
    return null;
}
let gcart;
let gparams;
let cantLoadMore;
let justQuery;
document.addEventListener("scroll", function () {
    cantLoadMore = true;
    // if(justQuery>0){
    //   let page = justQuery;
    //   justQuery = 0;
    //   gparams.set('page', page.toString());
    //   query(gcart, gparams);
    // }
});
export function SetupPagination(cart, params, wrapper, pageconf, items_len) {
    wrapper.innerHTML = "";
    let ul = document.createElement('ul');
    ul.classList.add('pagination');
    gcart = cart;
    gparams = params;
    if (items_len <= 0) {
        pageconf.total_pages = 0;
    }
    for (let i = 1; i < pageconf.total_pages + 1; i++) {
        let btn = LoadMoreButton(cart, params, i, pageconf.page);
        if (btn) {
            ul.appendChild(btn);
        }
    }
    wrapper.appendChild(ul);
}
export function render_pagination(cart, params, paginator, container, items_len) {
    if (paginator.page == 1) {
        cantLoadMore = false;
        justQuery = 0;
    }
    var pagination_element = document.querySelector(container);
    SetupPagination(cart, params, pagination_element, paginator, items_len);
}
let strict_filter = [];
export class Plugin {
    constructor(fun, op) {
        this.fun = fun;
        this.op = op;
    }
}
export function onFinishLoadProducts(cart) {
    window.Clkec.plugins.forEach(function (val) {
        val.fun(cart);
    });
}
var fbevents = Array.from([]);
export function query(cart, params, preload = false, updateUrl = false, options = defaultOptions) {
    openLoading();
    if (!params) {
        params = new URLSearchParams('');
    }
    console.log('CLKEC', 'query');
    // Filtrar y eliminar los parámetros con valores vacíos
    const nonEmptyParams = Array.from(params.entries())
        .filter(([_, value]) => value !== null && value !== undefined && value !== '')
        .map(([key, value]) => {
        if (value === 'null') {
            value = '';
        }
        return `${key}=${encodeURIComponent(value)}`;
    });
    // Construir la cadena de consulta
    let str_params = nonEmptyParams.length > 0 ? '?' + nonEmptyParams.join('&') : '';
    if (updateUrl) {
        window.history.replaceState({}, '', `${location.pathname}${str_params}`);
        var fbv = `${location.pathname}${str_params}`;
        ;
        if (fbevents.indexOf(fbv) < 0) {
            window.FBPageView();
            fbevents.push(fbv);
        }
    }
    if (preload) {
        window.Clkec.BannerRender('#banners');
        registerJsAddProduct(cart);
        registerJsFilters(cart);
        render_orderby(cart, params);
        let li = document.querySelector('#lisints_promotions_pagination ul li');
        if (li) {
            registerPaginationObserver(cart, li, 2, params);
        }
        closeLoading();
        return;
    }
    let url = window.API_URL + '/api/listings/' + str_params;
    clkecFetch(url, {
        method: 'GET',
        credentials: "include",
    }).then(response => {
        if (response.ok) {
            return response.json();
        }
        if (response.pagination) {
            return Promise.resolve(response);
        }
        return Promise.reject(response);
    }).then(data => {
        if (updateUrl) {
            window.history.replaceState({}, '', `${location.pathname}${str_params}`);
            var fbv = `${location.pathname}${str_params}`;
            ;
            if (fbevents.indexOf(fbv) < 0) {
                window.FBPageView();
                fbevents.push(fbv);
            }
        }
        window.Clkec.BannerRender('#banners');
        if (options.append) {
            render_items(cart, data.items, params, options);
            render_pagination(cart, params, data.pagination, '#lisints_promotions_pagination', data.items.length);
            closeLoading();
            return;
        }
        render_items(cart, data.items, params, options);
        render_pagination(cart, params, data.pagination, '#lisints_promotions_pagination', data.items.length);
        render_sidebar(cart, data.sidebar, params);
        render_actives(cart, data.actives, params);
        render_orderby(cart, params);
        closeLoading();
    }).catch(fetchError);
}
export function queryListener(cart, field, value, action) {
    var vals;
    if (action == 'add') {
        vals = addParam(field, value);
        vals.set('page', '1');
        query(cart, vals, false, true);
    }
    if (action == 'del') {
        vals = delParam(field, value);
        vals.set('page', '1');
        query(cart, vals, false, true);
    }
}
export const getFormJSON = (form) => {
    const data = new FormData(form);
    return Array.from(data.keys()).reduce((result, key) => {
        result[key] = data.get(key);
        return result;
    }, {});
};
export function setCookie(name, value, days) {
    var expires = "";
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + (days * 24 * 60 * 60 * 1000));
        expires = "; expires=" + date.toUTCString();
    }
    document.cookie = name + "=" + (value || "") + expires + "; path=/";
}
export function getCookie(name) {
    var nameEQ = name + "=";
    var ca = document.cookie.split(';');
    for (var i = 0; i < ca.length; i++) {
        var c = ca[i];
        while (c.charAt(0) == ' ')
            c = c.substring(1, c.length);
        if (c.indexOf(nameEQ) == 0)
            return c.substring(nameEQ.length, c.length);
    }
    return '';
}
export const SetCurrency = (value) => {
    if (GetCurrency() == value) {
        return;
    }
    setCookie(window.key_ec_currency, value, 1);
    window.Clkec.cart.setCurrency(value);
};
export const GetCurrency = () => {
    return getCookie(window.key_ec_currency);
};
export const SetWar = (value) => {
    if (value == 'None') {
        value = '';
    }
    setCookie(window.key_ec_war, value, 1);
};
export const GetWar = () => {
    return getCookie(window.key_ec_war);
};
export const SetUser = (value) => {
    return setCookie(window.key_ec_user, value, 1);
};
export const GetLang = () => {
    return getCookie(window.key_ec_lang);
};
export const SetLang = (value) => {
    return setCookie(window.key_ec_lang, value, 1);
};
export const formatAmount = (value, dp = null) => {
    if (value === undefined) {
        return '';
    }
    if (value === null) {
        return '';
    }
    var dl = dp;
    if (dl == null) {
        dl = window.DECIMAL_PLACES;
    }
    ;
    var ts = ',';
    var ds = '.';
    var re = '\\d(?=(\\d{3})+' + (dl > 0 ? '\\D' : '$') + ')';
    var num = value.toFixed(Math.max(0, ~~dl));
    return (ds ? num.replace('.', ds) : num).replace(new RegExp(re, 'g'), '$&' + ts);
};
export const SetLoc = (value) => {
    setCookie('ec_loc', value, 1);
};
export const GetLoc = () => {
    return getCookie('ec_loc');
};
export const clkecFetch = (url, options = {}, json = false) => {
    var params = {};
    params['w'] = GetWar();
    params['l'] = GetLoc();
    params['pc'] = GetCurrency();
    params['lang'] = GetLang();
    var headers = {};
    if (json) {
        headers['Content-Type'] = 'application/json; charset=utf-8';
    }
    // Tracking Meta (Facebook)
    try {
        const fbp = getCookie('_fbp') || getCookie('fbp');
        const fbc = getCookie('_fbc') || getCookie('fbc');
        const urlParams = typeof window !== 'undefined' && window.location ? new URLSearchParams(window.location.search) : null;
        const fbclid = urlParams ? urlParams.get('fbclid') : null;
        if (fbp)
            headers['X-FBP'] = fbp;
        if (fbc)
            headers['X-FBC'] = fbc;
        if (fbclid)
            headers['X-FBCLID'] = fbclid;
    }
    catch (e) {
        // Fallback silencioso si ocurre algún error accediendo a cookies o location
    }
    if (window.Clkec) {
        var user = window.Clkec.user;
        if (user) {
            headers['X-CLKECSESSIONID'] = user.getSessionId();
            let token = user.getToken();
            if (token) {
                headers["X-CLKECUSER"] = `${token.access_token}`;
            }
        }
    }
    const defaultOptions = {
        method: 'GET',
        headers: headers,
    };
    // Crear un AbortController para manejar el timeout
    const controller = new AbortController();
    const { signal } = controller;
    // Iniciar el timeout
    setTimeout(() => {
        controller.abort();
    }, TIMEOUT);
    // Fusionar las opciones por defecto con las proporcionadas
    const mergedOptions = Object.assign(Object.assign(Object.assign({}, defaultOptions), options), { headers: Object.assign(Object.assign({}, defaultOptions.headers), options.headers), signal: signal });
    // Analizar la URL actual para extraer los parámetros existentes
    const urlObject = new URL(url);
    const searchParams = new URLSearchParams(urlObject.search);
    for (const [key, value] of Object.entries(params)) {
        // Convertir el valor a string antes de agregarlo
        const valueString = String(value);
        if (!searchParams.has(key)) {
            searchParams.append(key, valueString);
        }
    }
    // Reconstruir la URL con los parámetros actualizados
    urlObject.search = searchParams.toString();
    const updatedUrl = urlObject.toString();
    // Realizar la solicitud fetch con las opciones fusionadas
    return fetch(updatedUrl, mergedOptions).then(response => {
        if (response.ok) {
            return response.json();
        }
        return Promise.reject(response);
    });
};
export function NewCartCode(length = 8) {
    const caracteres = 'ABCDEFGHIJKLMNOPQRSTUVWXYZ0123456789';
    let code = '';
    for (let i = 0; i < length; i++) {
        const randomIndex = Math.floor(Math.random() * caracteres.length);
        code += caracteres[randomIndex];
    }
    return code;
}
